<template>
	<v-dialog :value="value" max-width="340" @input="$emit('input', $event)">
		<v-card class="cd-card">
			<div class="cd-head">
				<v-icon color="primary" class="mr-2">mdi-palette-outline</v-icon>
				<div class="cd-title">{{ titolo }}</div>
				<v-spacer></v-spacer>
				<v-btn icon small title="Chiudi" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
			</div>

			<div class="cd-preview">
				<span class="cd-preview-label">Anteprima</span>
				<span class="cd-chip" :style="stileChip">{{ etichetta || 'Esempio' }}</span>
			</div>

			<div class="cd-picker">
				<v-color-picker v-model="colore" dot-size="11" mode="hexa" show-swatches swatches-max-height="100" hide-mode-switch width="100%" flat></v-color-picker>
			</div>

			<div class="cd-foot">
				<v-btn text color="primary" @click="$emit('input', false)">Annulla</v-btn>
				<v-btn depressed color="primary" @click="conferma">Usa questo colore</v-btn>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import { isDarkColor } from '@/Helper';

// scelta del colore di uno stato o di un tag ordine, con l'anteprima del chip come appare nella lista ordini
export default {
	name: 'ColoreDialog',
	props: {
		value: { type: Boolean, default: false },
		// colore di partenza (#RRGGBB o #RRGGBBAA)
		iniziale: { type: String, default: '#BDBDBD' },
		etichetta: { type: String, default: '' },
		titolo: { type: String, default: 'Colore' },
	},
	data() {
		return { colore: this.iniziale || '#BDBDBD' };
	},
	computed: {
		stileChip() {
			const c = typeof this.colore === 'string' ? this.colore : '#BDBDBD';
			return { backgroundColor: c, color: isDarkColor(c) ? '#FFFFFF' : '#000000' };
		},
	},
	watch: {
		// a ogni apertura si riparte dal colore attuale della riga
		value(aperto) {
			if (aperto) this.colore = this.iniziale || '#BDBDBD';
		},
	},
	methods: {
		conferma() {
			this.$emit('conferma', typeof this.colore === 'string' ? this.colore : this.iniziale);
			this.$emit('input', false);
		},
	},
};
</script>

<style scoped>
.cd-card {
	border-radius: 10px !important;
	overflow: hidden;
}
.cd-head {
	display: flex;
	align-items: center;
	padding: 12px 16px;
	border-bottom: 1px solid #e1e7ef;
}
.cd-title {
	font-weight: 600;
	font-size: 15px;
	color: #1f2d3d;
}
.cd-preview {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px 16px;
	background: #f3f6fa;
	border-bottom: 1px solid #e1e7ef;
}
.cd-preview-label {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
}
.cd-chip {
	display: inline-flex;
	align-items: center;
	height: 26px;
	padding: 0 12px;
	border-radius: 13px;
	border: 1px solid rgba(0, 0, 0, 0.12);
	font-size: 13px;
	font-weight: 500;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.cd-picker {
	padding: 8px;
}
.cd-foot {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 10px 16px;
	border-top: 1px solid #e1e7ef;
}
</style>
